import React, { Component, Fragment } from 'react';
import NotificationSystem from 'react-notification-system';
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners';
import { get } from '../../../server/actions'
import OrdersTable from './ordersTable';
import moment from 'moment';
import OrderDetails from './orderDetails';
import { groupBy,showFile, _addNotification, _addNotificationError } from '../../../server/util';
import {getLoginCatererInfo} from "../../../server/utilCaterer";
const defaultOrdersTableObj={
    day:{
        orders:[],
        summary:{},
        selectedDates:{
            startDate:moment().startOf('d'),
            endDate: moment().endOf('d'),
            cDate:moment()
        }
    },
    week:{
        orders:[],
        summary:{},
        selectedDates:{
            startDate:moment().startOf('w'),
            endDate: moment().endOf('w'),
            cDate:moment()
        }
    },
    month:{
        orders:[],
        summary:{},
        selectedDates:{
            startDate:moment().startOf('M'),
            endDate: moment().endOf('M'),
            cDate:moment()
        }
    }
}
const userInfo=getLoginCatererInfo();
const schools = userInfo.schools || [];
class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            schoolList: [],
            selectedSchoolId: this.props.selectSchool,
            mealType: this.props.mealType,
            ordersTable: {
                data: JSON.parse(JSON.stringify(defaultOrdersTableObj)),
                showOrderDetails: false,
                sid: 0,
                schoolYear:'',
                tableView:''
            }
        }
    }
    componentDidMount = () => {        
        const sid = schools.length > 0 ? schools[0].schoolId : 0
        const schoolYr = schools.length > 0 ? schools[0].activeSchoolYear : undefined;
        this.props.showHideSchoolsDropdown(true);
        this.setState({ selectedSchool: sid, schoolYear:schoolYr },()=>{
            this.getOrders('DAY');
            this.getOrders('WEEK');
            this.getOrders('MONTH');

        });
       
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({ selectedSchoolId: nextProps.selectSchool, mealType: nextProps.mealType }, () => {
            this.getOrders('DAY');
            this.getOrders('WEEK');
            this.getOrders('MONTH');
        })
    }
    getOrders = (tableView) => {
        const catId = sessionStorage.getItem('catererId');
        const periodKey=(tableView==='MONTH'?'month':(tableView==='WEEK'?'week':'day'));
        const dateStart = moment(this.state.ordersTable.data[periodKey].selectedDates.startDate).format('YYYY-MM-DD');
        const dateEnd = moment(this.state.ordersTable.data[periodKey].selectedDates.endDate).format('YYYY-MM-DD');
        const _url = this.props.selectSchool == 0 ? `/reports/catererOrdersReport?catererId=${catId}&menuType=${this.props.mealType}&startDate=${dateStart}&endDate=${dateEnd}&access_token=` :
            `/reports/catererOrdersReport?catererId=${catId}&menuType=${this.props.mealType}&mealSchoolId=${this.props.selectSchool}&startDate=${dateStart}&endDate=${dateEnd}&access_token=`;
        get(_url)
            .then((response) => {
                this.setState({ loading: true })
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(respData => {
                console.log('data', respData);
                let orders = [];
                let orderArray = [];
                (respData.response || []).map(item => {
                    Object.keys(item.orders).map(date => {
                        Object.keys(item.orders[date] || {}).map(type => {
                            ((item.orders[date] || {})[type] || []).map(rec => {
                                orderArray.push({ date: date, itemType: type, itemName: rec.itemName })
                            })
                        })
                    })
                });
                const itemNameGroup = groupBy(orderArray, 'itemName');
                Object.keys(itemNameGroup).map(itemName => {
                    const dateGroup = groupBy(itemNameGroup[itemName] || [], 'date')
                    const res = {};
                    res.itemName = itemName;
                    Object.keys(dateGroup).map(date => {
                        res[date] = dateGroup[date].length
                    })
                    orders.push(res);
                })
                let summary = respData.summary || {};
                let _ordersTable = this.state.ordersTable;
                _ordersTable.data[periodKey].orders= orders;
                _ordersTable.data[periodKey].summary= summary;
                this.setState({ ordersTable: _ordersTable, loading: false })
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
    }
    getCatererReportPdf = (type) => {
        const _props=this
	this.setState({loading: true});
    const sid=this.state.ordersTable.sid;
    const periodKey=(this.state.ordersTable.tableView==='MONTH'?'month':(this.state.ordersTable.tableView==='WEEK'?'week':'day'));
    const sDate=moment(this.state.ordersTable.data[periodKey].selectedDates.startDate).format('YYYY-MM-DD');
    const eDate=moment(this.state.ordersTable.data[periodKey].selectedDates.endDate).format('YYYY-MM-DD')
        if(type=='Email'){
            get(`/reports/catererExportReport?isVersion2=true&mealSchoolId=${sid}&startDate=${sDate}&endDate=${eDate}&menuType=${this.props.mealType}&fileType=Pdf&byItem=${false}&catererEmail=${this.state.catererEmail}&access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();                
            }).then(data => { 
                if(data.statusCode==200){
                    _addNotification(data.statusMessage,_props);
                    this.setState({openCatererModal:false, catererEmail:'', loading:false});
                }else{
                    _addNotification(data.errorMessage,_props);
                    this.setState({openCatererModal:false, catererEmail:'', loading:false});
                }
                                 
            }).catch(error => {
                _addNotification(error,_props);
                this.setState({openCatererModal:false, catererEmail:'', loading:false});
            });
        }else{
            get(`/reports/catererExportReport?isVersion2=true&mealSchoolId=${sid}&startDate=${sDate}&endDate=${eDate}&menuType=${this.props.mealType}&fileType=Pdf&byItem=${false}&access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
		this.setState({loading: false});
                return response.blob();
                
            }).then(blob => {
                    let filename = "Caterer Reports for " /* + (grade === 0 ? 'all grades' : 'grade-' + grade) */;
        
                    //if (fileType === "Pdf") {
                    // download(blob,filename + '.pdf', "pdf");
                    showFile(blob,filename);
                    //}
                /*  else {
                        download(blob,
                            filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    } */
            }).catch(error => {
		this.setState({loading: false});
                console.log("Download Failed", error)
            });
        }
    }
    render() {
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    {
                        !this.state.ordersTable.showOrderDetails ?
                            <div className="row">
                                <div className=" col-md-12">
                                    <div className="row">
                                        <div className="col-md-4">
                                        <OrdersTable {...this.props} {...this} tableView={'DAY'} 
                                        data={this.state.ordersTable.data.day}
                                            onSchoolClick={(sid) => {
                                                const _orderTable = this.state.ordersTable;
                                                _orderTable.sid = sid;
                                                const schoolYr=(schools.find(school=>{
                                                    return school.schoolId==sid
                                                })||{}).activeSchoolYear;
                                                _orderTable.schoolYear=schoolYr;
                                                _orderTable.tableView='DAY';
                                                    //_orderTable.showOrderDetails = true
                                                this.setState({ ordersTable: _orderTable },()=>{
                                                    this.context.router.history.push({ 
                                                        pathname: '/caterer/orderDetails',
                                                        state: {
                                                            data:_orderTable,
                                                            props:{
                                                                mealType: this.props.mealType,
                                                                schoolList: this.props.schoolList,
                                                                selectSchool: this.props.selectSchool,
                                                                showSchoolDropdown: this.props.showSchoolDropdown
                                                            }
                                                        }
                                                       });
                                            })}}/>
                                        </div>
                                        <div className="col-md-4">
                                            <OrdersTable {...this.props} {...this} tableView={'WEEK'}
                                                data={this.state.ordersTable.data.week}
                                            onSchoolClick={(sid) => {
                                                const _orderTable = this.state.ordersTable;
                                                _orderTable.sid = sid;
                                                const schoolYr=(schools.find(school=>{
                                                    return school.schoolId==sid
                                                })||{}).activeSchoolYear;
                                                _orderTable.schoolYear=schoolYr;
                                                   // _orderTable.showOrderDetails = true;
                                                    _orderTable.tableView='WEEK';
                                                this.setState({ ordersTable: _orderTable },()=>{
                                                    this.context.router.history.push({ 
                                                        pathname: '/caterer/orderDetails',
                                                        state: {
                                                            data:_orderTable,
                                                            props:{
                                                                mealType: this.props.mealType,
                                                                schoolList: this.props.schoolList,
                                                                selectSchool: this.props.selectSchool,
                                                                showSchoolDropdown: this.props.showSchoolDropdown
                                                            }
                                                        }
                                                       } );
                                                });
                                            }}/>
                                        </div>
                                        <div className="col-md-4">
                                            <OrdersTable {...this.props} {...this} tableView={'MONTH'}
                                            data={this.state.ordersTable.data.month}
                                            onSchoolClick={(sid) => {
                                                const _orderTable = this.state.ordersTable;
                                                _orderTable.sid = sid
                                                const schoolYr=(schools.find(school=>{
                                                    return school.schoolId==sid
                                                })||{}).activeSchoolYear
                                                    _orderTable.showOrderDetails = true;
                                                    _orderTable.schoolYear=schoolYr;
                                                    _orderTable.tableView='MONTH';
                                                this.setState({ ordersTable: _orderTable },()=>{
                                                    this.context.router.history.push({ 
                                                        pathname: '/caterer/orderDetails',
                                                        state: {
                                                            data:_orderTable,
                                                            props:{
                                                                mealType: this.props.mealType,
                                                                schoolList: this.props.schoolList,
                                                                selectSchool: this.props.selectSchool,
                                                                showSchoolDropdown: this.props.showSchoolDropdown
                                                            }
                                                        }
                                                       });
                                            })
                                            }} />
                                        </div>
                                    </div>                                    
                                </div>
                            </div> : null
                    }
                    {/* {
                        this.state.ordersTable.showOrderDetails ?
                           <Fragment> 
                                <div className="row">
                                    <OrderDetails {...this.props} {...this}
                                    data={this.state.ordersTable}
                                    onBack={()=>{
                                        const _orderTable = this.state.ordersTable;
                                            _orderTable.sid = 0,
                                            _orderTable.showOrderDetails = false;
                                            _orderTable.data=JSON.parse(JSON.stringify(defaultOrdersTableObj)),
                                        this.setState({ ordersTable: _orderTable },()=>{
                                            this.getOrders('DAY');
                                            this.getOrders('WEEK');
                                            this.getOrders('MONTH');
                                        });                                        
                                    }}
                                        onChangeDateRange={(start, end) => {
                                            const _orderTable = this.state.ordersTable;
                                            _orderTable.selectedDates.startDate = start;
                                            _orderTable.selectedDates.endDate = end;
                                            this.setState({ ordersTable: _orderTable }, () => {
                                                this.getOrders();
                                            });
                                        }}
                                        onTableViewChange={(view)=>{
                                            const {ordersTable}=this.state;
                                            ordersTable.tableView=view;
                                            this.setState({ordersTable:ordersTable});
                                        }}
                                    />
                                </div></Fragment> : null
                    } */}
                </div>
            </section>
        );
    }
}
Orders.contextTypes = {
    router: PropTypes.object.isRequired
}
export default Orders;


// WEBPACK FOOTER //
// ./src/components/Caterer/Orders/index.jsx